import AccordionItem from 'components/ui-kit/AccordionItem/index'
// import { FooterLogo } from 'components/ui-kit/Icons/svg/index'
import config from 'config/app.config'
import { SHOW_SIDE_NAV } from 'constants/index'
import { getItem } from 'helpers/localstorage.helpers'
import moment from 'moment'
import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { getAllSiteinfo } from 'redux-thunk/thunk/gameSetting'
import AboutUs from './components/AboutUs/index'
import Community from './components/Community/index'
import SupportAndSocial from './components/SupportAndSocial/index'
import LanguageDropdown from './components/LanguageDropdown/index'
import { InfoIcon } from 'components/ui-kit/Icons/svg/index'
// import Platform from './components/Platform/index'

const footerTopTextStyles =
  '[&_p]:text-xs [&_p]:font-medium [&_p]:leading-[1.063rem] [&_p]:text-[var(--gray-20)]'

const footerLinkingStyles =
  'flex flex-col justify-between p-0 [&_a]:block [&_a]:py-[0.313rem] [&_a]:text-sm [&_a]:font-medium [&_a]:text-[var(--gray-20)] [&_a:hover]:text-gold [&_h4]:m-0 [&_h4]:pb-[0.2rem] [&_h4]:text-base [&_h4]:font-medium [&_h4]:uppercase [&_h4]:text-white'

const desktopLanguageStyles =
  'mx-auto max-w-[1400px] pb-6 max-sm:p-0 [&_.btn-secondary]:flex [&_.btn-secondary]:w-auto [&_.btn-secondary]:min-h-8 [&_.btn-secondary]:items-center [&_.btn-secondary]:justify-center [&_.btn-secondary]:rounded [&_.btn-secondary]:border [&_.btn-secondary]:border-[var(--footerBorder)] [&_.btn-secondary]:bg-[var(--selectBg)] [&_.btn-secondary]:text-xs [&_.btn-secondary]:font-normal [&_.btn-secondary]:text-[var(--gray-20)] [&_.btn-secondary_img]:mr-[0.313rem] [&_.btn-secondary_img]:h-4 [&_.btn-secondary_img]:w-4 [&_.language-wrap]:flex [&_.language-wrap]:items-center [&_.language-wrap]:justify-between [&_.language-wrap]:border-t [&_.language-wrap]:border-[var(--gray-80)] [&_.language-wrap]:pt-4 max-sm:[&_.language-wrap]:mb-8 max-sm:[&_.language-wrap]:border-t-0 max-sm:[&_.language-wrap]:pt-0 [&_.language-wrap_p]:text-xs [&_.language-wrap_p]:font-medium [&_.language-wrap_p]:leading-[1.063rem] [&_.language-wrap_p]:text-[var(--gray-20)] max-sm:[&_.language-wrap_p]:hidden'

const accordionStyles =
  'border-b border-[var(--gray-80)] [&_.accordion-animation]:animate-[accordianEffect_400ms_ease-in-out_both] [&_.accordion-body]:rounded-b-[0.875rem] [&_.accordion-body]:bg-[var(--gray-90)] [&_.accordion-body]:px-0 [&_.accordion-body]:pb-6 [&_.accordion-body]:pt-1 [&_.accordion-body]:text-base [&_.accordion-body]:text-white max-md:[&_.accordion-body]:text-sm [&_.accordion-body_a]:block [&_.accordion-body_a]:py-2 [&_.accordion-body_a]:text-sm [&_.accordion-body_a]:font-medium [&_.accordion-body_a]:text-[var(--gray-20)] [&_.accordion-button]:relative [&_.accordion-button]:border-0 [&_.accordion-button]:border-t [&_.accordion-button]:border-[var(--gray-80)] [&_.accordion-button]:bg-[var(--gray-90)] [&_.accordion-button]:px-0 [&_.accordion-button]:py-4 [&_.accordion-button]:text-base [&_.accordion-button]:font-medium [&_.accordion-button]:capitalize [&_.accordion-button]:leading-6 [&_.accordion-button]:text-white [&_.accordion-button]:shadow-none [&_.accordion-button]:focus:shadow-none [&_.accordion-button:after]:opacity-0 [&_.accordion-button.accordionClose]:!text-white [&_.accordion-button.accordionOpen]:!pb-3 [&_.accordion-icon]:absolute [&_.accordion-icon]:right-4 [&_.accordion-icon_svg]:w-8 [&_.accordion-item]:m-0 [&_.accordion-item]:border-0 [&_.accordion-item]:bg-transparent'

const footerBottomLinkingStyles =
  'bg-[var(--darkGray)] p-[1.2rem] [&_a]:px-[0.3rem] [&_a]:font-medium [&_a]:text-white [&_p]:relative [&_p]:m-0 [&_p]:px-2.5 [&_p]:text-xs [&_p]:font-medium [&_p]:text-[var(--gray-20)] [&_p:not(:last-child)]:before:absolute [&_p:not(:last-child)]:before:right-0 [&_p:not(:last-child)]:before:top-0 [&_p:not(:last-child)]:before:h-full [&_p:not(:last-child)]:before:w-px [&_p:not(:last-child)]:before:bg-white [&_p:not(:last-child)]:before:content-[\'\']'

const Footer = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { siteInfo } = useSelector(state => state.user)
  const { showSideNav, showChat } = useSelector(
    (state) => state?.settings
  )
  const showSidebarNav = getItem(SHOW_SIDE_NAV)
  const [isCollapseAccordion, setIsCollapseAccordion] = useState({
    accordionOne: false,
    accordionTwo: false,
    accordionThree: false,
    accordionFour: false
  })
  const hasSupportAndSocial = siteInfo?.some(
    (el) => el.cmsSection === 'supportAndSocial'
  )
  const currentYear = moment().year()

  const accordionClickHandler = useCallback((accordionId) => {
    setIsCollapseAccordion((prevState) => ({
      ...prevState,
      [accordionId]: !prevState[accordionId]
    }))
  }, [])

  useEffect(() => {
    if (!siteInfo) { dispatch(getAllSiteinfo()) }
  }, [])

  useEffect(() => {
    const el = document.getElementById('anj-f6119bb2-07b1-422d-9d1a-40202a8999fb')
    if (!el) return
    const initSeal = () => {
      if (
        window.anj_f6119bb2_07b1_422d_9d1a_40202a8999fb
      ) {
        window.anj_f6119bb2_07b1_422d_9d1a_40202a8999fb.init()
      } else {
        setTimeout(initSeal, 500)
      }
    }

    initSeal()
  }, [])

  const decodeHTML = (html) => {
    const txt = document.createElement('textarea')
    txt.innerHTML = html
    return txt.value
  }

  const footerMenuSidebarStyles =
    showSideNav && showChat
      ? 'min-[1400px]:basis-full min-[1400px]:max-w-full min-[1400px]:pl-0 min-[1400px]:pt-8'
      : ''

  return (
    <footer
      className={`mt-3 px-3 bg-black [background:linear-gradient(145deg,#472e00,#090b0b_25%)_padding-box,linear-gradient(135deg,#8a6500,#ffd700,#b8860b,#b8860b,#8a6500)_border-box] ${showSideNav && showChat ? 'min-[1400px]:mr-px' : ''}`}
    >
      <div className={`hidden p-0 sm:block ${footerTopTextStyles}`}>
        <div className='mx-auto flex max-w-[1400px] flex-wrap py-12 pb-4 px-4'>
          <div className='max-w-[18.75rem] shrink-0 basis-[18.75rem]'>
            <div className='mb-3'>
              <div className='mb-2.5 [&_img]:max-h-[65px]'>
                {/* <NewClutchLogoIcon /> */}
                <img src='/assets/images/logo.png' alt='footer_logo' />

                <p>
                pretrade.io is owned and operated by 3-102-950787 LIMITADA. registration number: 3-
              102-950787.
                </p>
              </div>
              <p className='m-0 [&_p]:!mb-0'>
                <div
                  dangerouslySetInnerHTML={{
                    __html: decodeHTML(siteInfo?.filter(item => item?.title === 'Footer address')?.[0]?.content || '')
                  }}
                />
              </p>
            </div>
            {/* <div className='my-3'>
              <p className='m-0'>{t('tradingDefinition')}</p>
            </div> */}
          </div>
          <div
            className={`flex max-w-full flex-1 flex-wrap justify-between gap-8 pl-[7.5rem] max-lg:basis-full max-lg:max-w-full max-lg:pl-0 max-lg:pt-8 ${footerMenuSidebarStyles}`}
          >
            {/* <div>
              <div className={footerLinkingStyles}>
                <h4 className='m-0'>{t('platform')}</h4>
                <Platform />
              </div>
            </div> */}
            <div>
              <div className={footerLinkingStyles}>
                <h4 className='m-0'>{t('aboutUs')}</h4>
                <AboutUs />
              </div>
            </div>
            {hasSupportAndSocial && (
              <div>
                <div className={footerLinkingStyles}>
                  <h4 className='m-0'>{t('supportAndSocial')}</h4>
                  <SupportAndSocial />
                </div>
              </div>
            )}
            <div>
              <div className={footerLinkingStyles}>
                <h4 className='m-0'>{t('community')}</h4>
                <Community />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={`block p-0 sm:hidden max-md:pb-5 max-md:pt-10 max-sm:pb-8 ${footerTopTextStyles}`}>
        <div className='order-3 w-full lg:order-none'>
          <div className='mb-3'>
            <div className='mb-2.5 [&_img]:max-h-[65px]'>
              <img src='assets/images/logo.png' alt='footer_logo' />
            </div>
            <p className='m-0'>{t('copyrightText', { year: currentYear })}</p>
          </div>
          <div className='my-3'>
            <p className='m-0'>{t('tradingDefinition')}</p>
          </div>
        </div>
        {/* <div className={`block pt-4 lg:hidden ${desktopLanguageStyles}`}>
          <LanguageDropdown />
        </div> */}
        <div className={accordionStyles} id='accordionExample'>
          {/* <AccordionItem
            accordionId='accordionOne'
            isCollapseAccordion={isCollapseAccordion}
            accordionClickHandler={accordionClickHandler}
            title={t('platform')}
          >
            <Platform />
          </AccordionItem> */}
          <AccordionItem
            accordionId='accordionTwo'
            isCollapseAccordion={isCollapseAccordion}
            accordionClickHandler={accordionClickHandler}
            title={t('aboutUs')}
          >
            <AboutUs />
          </AccordionItem>
          {hasSupportAndSocial && (
            <AccordionItem
              accordionId='accordionFour'
              isCollapseAccordion={isCollapseAccordion}
              accordionClickHandler={accordionClickHandler}
              title={t('supportAndSocial')}
            >
              <SupportAndSocial />
            </AccordionItem>
          )}
          <AccordionItem
            accordionId='accordionThree'
            isCollapseAccordion={isCollapseAccordion}
            accordionClickHandler={accordionClickHandler}
            title={t('community')}
          >
            <Community />
          </AccordionItem>
        </div>
        {/* <div
              id='anj-f6119bb2-07b1-422d-9d1a-40202a8999fb'
              data-anj-seal-id='f6119bb2-07b1-422d-9d1a-40202a8999fb'
              data-anj-image-size='128'
              data-anj-image-type='basic-small'
            /> */}
      </div>
      {/* <div className={`hidden pt-0 sm:block ${desktopLanguageStyles}`}>
        <LanguageDropdown currentYear={currentYear} />
      </div> */}

      <div>
        <div className='mx-auto flex max-w-[1400px] flex-wrap pb-4 px-4'>
          <div className='flex items-center justify-center gap-4'>
            <div>
              <InfoIcon width={48} height={48} fill='var(--gray-40)' name='info-circle' />
            </div>
            <p className='m-0 text-sm text-gray-500'>pretrade.io is owned and operated by 3-102-950787 LIMITADA. registration number: 3-
              102-950787, registered address: Provincia de Puntarenas 06, Canton 11, Garabito, Jaco, Costa
              Rica. Contact us support@pretrade.io. pretrade.io is licensed and regulated by the
              Government of the Autonomous Island of Anjouan, Union of Comoros and operates under
              License No. ALSI-202603037-F12. pretrade.io has passed all regulatory complianceand is
              legally authorized to conduct gaming operations for any and all games of chance and wagering.
            </p>
          </div>
        </div>
      </div>
      <div
        className={`${footerBottomLinkingStyles} max-md:border-b max-md:border-[var(--gray-80)] md:flex md:items-center md:justify-center [&_p]:max-md:text-center`}
      >
        <p className='m-0'>
          {t('support')}
          <a href='mailto:support@pretrade.io'>support@pretrade.io</a>
        </p>
        <p className='m-0'>
          {t('partners')}
          <a href='mailto:partners@pretrade.io'>partners@pretrade.io</a>
        </p>
        <p className='m-0'>
          {t('legal')}
          <a href='mailto:legal@pretrade.io'>legal@pretrade.io</a>
        </p>
      </div>
      <div
        className={`${footerBottomLinkingStyles} flex items-center justify-center sm:hidden`}
      >
        <p className='mb-0'>© {currentYear} pretrade.io All rights reserved.</p>
      </div>
    </footer>
  )
}

export default React.memo(Footer)
